import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation SpaceRecordSignOffLite(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordSignOff(
                  spaceRecordIds: $spaceRecordIds
                  onlyLite: true
                )
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceRecordSignOffLiteMutation,
    readonly ents.core.dms.data.Record.Id[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceRecordSignOff',
                graphql.transformers.OUT.default(
                  graphql.transformers.OUT.list(
                    graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.core.dms.data.Record.Id.isId,
                    ),
                  ),
                  [],
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordSignOffLiteMutation,
  readonly ents.core.dms.data.Record.Id[],
  graphql.schema.SpaceRecordSignOffLiteMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
